import { render, staticRenderFns } from "./BaseMultiSelectItem.vue?vue&type=template&id=3a55790a&scoped=true&"
import script from "./BaseMultiSelectItem.vue?vue&type=script&lang=js&"
export * from "./BaseMultiSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseMultiSelectItem.vue?vue&type=style&index=0&id=3a55790a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a55790a",
  null
  
)

export default component.exports